module.exports = __webpack_public_path__ + "img/2.84b09085.png";